import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectSubBaseComponent} from "../object-sub-base.component";
import {ConfirmationService} from "primeng/api";
import {CustomerService} from "../../../../../service/api/customer.service";
import {CustomerContractService} from "../../../../../service/api/customer-contract.service";
import {CustomersContractsObjectsRuntime} from "./data/customer-contracts-object-runtime";
import {CustomerContractPersonWidgetStyle} from "./uiStyle/customer-contract-person-widget-style";
import {ObjectInfo} from "./data/object-info";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {MvsObjectNavigationService} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {MvsConfigService} from "../../../../../../../core/shared/config/mvs-config.service";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {PersonRelationPersonService} from "../../../../../../pm/service/api/person-relation-person.service";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {CustomerDto} from "../../../../../model/dto/entity/customer.dto";

// NOT_IN_USE
@Component({
    selector: 'cr-customer-new-contracts',
    templateUrl: './cr-customer-new-contracts.component.html',
    standalone: false
})
export class CrCustomerNewContractsComponent extends ObjectSubBaseComponent implements OnInit, OnChanges, OnDestroy {

    householdPersonService: MvsCrudService;
    @Input() viewType: string;

    customerContractsWidget: WidgetData;
    personRelationWidget: WidgetData;
    insurableObjectsWidget: WidgetData;
    householdPersonsWidget: WidgetData;
    showActive: boolean = true;
    customerContractsRuntime: CustomersContractsObjectsRuntime;
    contractPersonWidgetStyle: CustomerContractPersonWidgetStyle;
    personRelationObjects: ObjectInfo[];
    householdPersonObjects: ObjectInfo[];
    insuredObjects: ObjectInfo[];
    selectedRelationPersonContractIds: Set<number> = new Set<number>();
    selectedInsuredObjectContractIds: Set<number> = new Set<number>();
    selectedHouseholdPersonContractIds: Set<number> = new Set<number>();


    ngOnInit(): void {
        this.initComponent();
    }

    constructor(protected navigationService: MvsObjectNavigationService,
                protected coreService: MvsCoreService,
                protected confirmationService: ConfirmationService,
                protected messageService: MvsMessageService,
                protected customerService: CustomerService,
                protected customerContractService: CustomerContractService,
                protected configService: MvsConfigService,
                protected personRelationPersonService: PersonRelationPersonService) {
        super(coreService, confirmationService, messageService, configService, navigationService,customerService,personRelationPersonService);


        this.householdPersonService = this.coreService.getCrudService("pm.HouseholdPerson");
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.contractPersonWidgetStyle = new CustomerContractPersonWidgetStyle(this.configService, this.dto as CustomerDto, []);
        this.getContractsRuntime();
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["objectIdentifier"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    getContractsRuntime() {
        this.customerContractService.getCustomerContracts(this.objectIdentifier.objectId, this.showActive).subscribe(res => {
            this.customerContractsRuntime = res;
            this.contractPersonWidgetStyle.setCustomerContracts(this.customerContractsRuntime.customerContracts);
            this.postContractsProcessing();
            this.initialized = true;
        });
    }

    getBaseContractsFilter(): FilterCriteria {
        const filter = this.prepareInFilter(this.selectedHouseholdPersonContractIds);
        // return this.prepareInFilter(this.customerContractsRuntime.contractIds);
        return filter;
    }

    postContractsProcessing() {
        this.prepareHouseholdWidgetStyle();
        const filterCriteria = this.getBaseContractsFilter();
        this.getAllContracts(filterCriteria);
        this.refreshWidgets();
    }

    getAllContracts(filter: FilterCriteria) {


        this.customerContractsWidget = WidgetFactory.createWidgetList(
            'cr.customer.basic.contract.new',
            'Verträge',
            'table',
            'list',
            'entity',
            'cm.Contract',
            null,
            ObjectRequestList.createBasic(true, [filter], [])
        );
    }

    refreshWidgets() {
        if (!this.customerContractsRuntime || !this.customerContractsRuntime.objectInfos?.length) {
            return;
        }


        this.preparePersonRelationPersonWidget();
        this.prepareInsurableObjectsWidget();
        this.prepareHouseholdPersonsWidget();

    }

    preparePersonRelationPersonWidget() {

        this.personRelationObjects = this.customerContractsRuntime.objectInfos.filter(item => item.objectAlias == 'pm.Person');

        for (let item of this.personRelationObjects) {
            item['__count'] = this.customerContractService.getUniqueRecordsCount(item.id, this.customerContractsRuntime.personContracts);
        }

        this.personRelationWidget = WidgetFactory.createWidgetTransientExpandable(
            "cr.customer.new.contracts.navigation",
            'Verknüpfte Personen',
            'transientExpandable',
            'pm.Person',
            this.personRelationObjects,
            new ObjectRequestList(true, [], [])
        );

    }

    prepareHouseholdWidgetStyle() {
        this.householdPersonObjects = [];

        const clonedInfo = structuredClone(this.customerContractsRuntime.objectInfos);
        for (let item of this.customerContractsRuntime.householdPersonsIds) {
            const person = clonedInfo.find(value => item == value.id);
            if (person) {
                this.householdPersonObjects.push(person);
            }
        }

        for (let person of this.householdPersonObjects) {
            const customer = this.customerContractsRuntime.personCustomers.find(item => item.fromId == person.id);
            if (!customer) {
                continue; //we are only handling customers
            }

            const contracts = this.customerContractsRuntime.customerContracts.filter(value => value.fromId === customer.toId);
            contracts.forEach(c => this.selectedHouseholdPersonContractIds.add(c.toId));
            person['__selected'] = true;
            // this.contractPersonWidgetStyle.handleHouseholdPerson(person as any);
        }


        // for (let item of this.customerContractsRuntime.householdPersonsIds) {
        //     const person = this.customerContractsRuntime.objectInfos.find(value => item == value.id);
        //     if (person) {
        //         const customer = this.customerContractsRuntime.personCustomers.find(item => item.fromId == person.id);
        //         if (!customer) {
        //             continue; //we are only handling customers
        //         }
        //
        //         const contracts = this.customerContractsRuntime.customerContracts.filter(value => value.fromId === customer.toId);
        //         contracts.forEach(c => this.selectedHouseholdPersonContractIds.add(c.toId));
        //         this.contractPersonWidgetStyle.handleHouseholdPerson(person as any);
        //     }
        //
        // }
        this.contractPersonWidgetStyle = this.contractPersonWidgetStyle.clone();
    }

    prepareInsurableObjectsWidget() {
        this.insuredObjects = this.customerContractsRuntime.objectInfos.filter(item => item.objectAlias == 'ci.InsurableObject');

        for (let item of this.insuredObjects) {
            item['__count'] = this.customerContractService.getUniqueRecordsCount(item.id, this.customerContractsRuntime.insurableObjectContracts);
        }

        this.insurableObjectsWidget = WidgetFactory.createWidgetTransientExpandable(
            "cr.customer.new.insurable.objects.navigation",
            'Insurable Objects',
            'transientExpandable',
            'ci.InsurableObject',
            this.insuredObjects,
            new ObjectRequestList(true, [], [])
        );
    }

    prepareHouseholdPersonsWidget() {

        for (let item of this.householdPersonObjects) {
            item['__count'] = this.customerContractService.getUniqueRecordsCount(item.id, this.customerContractsRuntime.customerContracts);
            // item['__count'] = this.customerContractsRuntime.customerContracts.filter(value => value.fromId == item.id)?.length;
        }


        this.householdPersonsWidget = WidgetFactory.createWidgetTransientExpandable(
            "cr.customer.new.household.persons.navigation",
            'Personen im Haushalt',
            'transientExpandable',
            'pm.Person',
            this.householdPersonObjects,
            new ObjectRequestList(true, [], [])
        );
    }

    // getUniqueRecordsCount(attribute: number, entries: ObjectRelation[]): number {
    //     const records = entries.filter(value => value.fromId == attribute);
    //     const uniqueContracts = new Set<string>();
    //     for (const contract of records) {
    //         const normalizedPair = `${Math.min(contract.fromId, contract.toId)}-${Math.max(contract.fromId, contract.toId)}`;
    //         uniqueContracts.add(normalizedPair);
    //     }
    //     return uniqueContracts.size;
    // }

    prepareInFilter(entries: Set<number>, attribute: string = 'id') {
        let ids: number[] = [];

        for (let entry of entries) {
            ids.push(entry);
        }
        return FilterCriteria.create(attribute, FilterCriteria.cOperatorIn, ids);

    }

    handleToggleContracts() {
        this.showActive = !this.showActive;
        this.refreshComponent();
    }

    handleHouseholdPersonSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedHouseholdPersonContractIds = new Set<number>();
        for (let person of this.householdPersonObjects) {
            if (person['__selected']) {
                const customer = this.customerContractsRuntime.personCustomers.find(item => item.fromId == person.id);
                if (!customer) {
                    continue; //we are only handling customers
                }

                const contracts = this.customerContractsRuntime.customerContracts.filter(value => value.fromId === customer.toId);
                contracts.forEach(c => this.selectedHouseholdPersonContractIds.add(c.toId));
            }
        }
        this.reloadContracts();

        const event1 = event as ObjectIdentifierData;
        const person = event1.data;

        const customer = this.customerContractsRuntime.personCustomers.find(item => item.fromId == person.id);

        // || !person['__selected']
        if (!customer) {
            return; //we are only handling customers
        }

        // this.contractPersonWidgetStyle.handleHouseholdPerson(event.data);
        this.contractPersonWidgetStyle = this.contractPersonWidgetStyle.clone();

    }

    handleRelatedPersonSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedRelationPersonContractIds = new Set<number>();
        try {
            for (let item of this.personRelationObjects) {
                if (item['__selected'] === true) {
                    const contracts = this.customerContractsRuntime.personContracts.filter(
                        value => value.fromId === item.id
                    );
                    contracts.forEach(c => this.selectedRelationPersonContractIds.add(c.toId));
                }
            }
            this.reloadContracts();
        } catch (error) {
            console.error("Error in handleRelatedPersonSelect:", error);
        }
    }

    handleInsuredObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedInsuredObjectContractIds = new Set<number>();
        try {
            for (let item of this.insuredObjects) {
                if (item['__selected'] === true) {
                    const contracts = this.customerContractsRuntime.insurableObjectContracts.filter(
                        value => value.fromId === item.id
                    );
                    contracts.forEach(c => this.selectedInsuredObjectContractIds.add(c.toId));
                }
            }
            this.reloadContracts();
        } catch (error) {
            console.error("Error in handleRelatedPersonSelect:", error);
        }
    }

    reloadContracts() {
        let combinedSet = new Set<number>();
        let filter: FilterCriteria;
        if (this.selectedRelationPersonContractIds.size || this.selectedInsuredObjectContractIds.size) {
            combinedSet = new Set<number>([...this.selectedRelationPersonContractIds, ...this.selectedInsuredObjectContractIds]);
            const intersection = new Set([...combinedSet].filter(id => this.selectedHouseholdPersonContractIds.has(id))); // only unique ids from left side and right side
            filter = this.prepareInFilter(intersection);
        } else {
            filter = this.getBaseContractsFilter();
        }
        this.getAllContracts(filter);

    }

}
